import {FC} from 'react'
import {Trans} from 'react-i18next'

import {withStyles, WithStyles} from '@material-ui/core'
import classNames from 'classnames'

import messages from '../../../../../../assets/messages'
import {styles} from './styles'

const referralCode = 'y70kse'
const premierLink = `https://fantasy.premierleague.com/leagues/auto-join/${referralCode}`
const eligibleAmount = 250

export const PremierLeagueBanner: FC<WithStyles & {isClientEligible: boolean}> = ({
  classes,
  isClientEligible,
}) => {
  const bodyHeadContent = isClientEligible ? (
    <Trans {...messages.leagueBannerEligibleHeader} />
  ) : (
    <Trans {...messages.leagueBannerInitialHeader} />
  )

  const bodyMainContent = isClientEligible ? (
    <a
      href={premierLink}
      target="_blank"
      rel="noopener noreferrer"
      className={classNames(classes.body, classes.eligibleBody)}
    >
      <Trans
        {...messages.leagueBannerEligibleBody}
        components={[<span className={classes.highlight}>code</span>]}
        values={{referralCode}}
      />
    </a>
  ) : (
    <div className={classes.body}>
      <Trans
        {...messages.leagueBannerInitialBody}
        components={[<span className={classes.highlight}>code</span>]}
        values={{eligibleAmount}}
      />
    </div>
  )

  return (
    <div
      className={classNames(classes.container, {
        [classes.initialContainerBackground]: !isClientEligible,
        [classes.eligibleContainerBackground]: isClientEligible,
      })}
    >
      <div className={classes.bannerBody}>
        <div className={classes.bodyHead}>{bodyHeadContent}</div>
        {bodyMainContent}
      </div>
    </div>
  )
}

export default withStyles(styles, {withTheme: true})(PremierLeagueBanner)
